import { render } from "./InputForm.vue?vue&type=template&id=bd131a78&lang=true"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"
script.render = render

export default script